import React from "react";
import { useTheme } from "@mui/material";

import { Legend, LegendItem } from "@tiny/components";

function GeolocationLegend() {
  const theme = useTheme();

  return (
    <Legend mt={6}>
      <LegendItem color={theme.palette.primary.lighter}>&lt; 100</LegendItem>
      <LegendItem color={theme.palette.primary.light}>&lt; 500</LegendItem>
      <LegendItem color={theme.palette.primary.main}>&lt; 1000</LegendItem>
      <LegendItem color={theme.palette.primary.dark}>1000+</LegendItem>
    </Legend>
  );
}

export default React.memo(GeolocationLegend);
